import { createReducer } from '../helpers';
import { api } from '../actions';

const setIsFetching = (bool) => (state) => {
    state.isFetching = bool;
};

const setLastRequest = (state) => {
    if (!__LEGACY__) {
        return state;
    }

    return {
        ...state,
        lastRequest: Date.now(),
    };
};

const setSuccessResult = (state, action) => {
    if (__LEGACY__) {
        const items = action.result.items.filter((i) => !i.website);

        return {
            ...state,
            ...action.result,
            items,
            isFetching: false,
            lastRequest: Date.now(),
        };
    }

    return {
        ...state,
        ...action.result,
        isFetching: false,
        lastRequest: Date.now(),
    };
};

const initialState = {
    items: [],
    isFetching: false,
    allPublishedProductsCount: 0,
    allCollectionsCount: 0,
    publishedCollectionsCount: 0,
    allProductsCount: 0,
    lastRequest: null,
};

export default createReducer(initialState, {
    [api.collections.list.request]: setIsFetching(true),
    [api.collections.retrieve.request]: setIsFetching(true),
    [api.collections.create.request]: setIsFetching(true),
    [api.collections.update.request]: setIsFetching(true),
    [api.collections.delete.request]: setIsFetching(true),
    [api.collections.products.update.request]: setIsFetching(true),
    [api.collections.sort.request]: setIsFetching(true),
    [api.products.migrate.request]: setIsFetching(true),

    [api.collections.list.failure]: setIsFetching(false),
    [api.collections.retrieve.failure]: setIsFetching(false),
    [api.collections.create.failure]: setIsFetching(false),
    [api.collections.update.failure]: setIsFetching(false),
    [api.collections.delete.failure]: setIsFetching(false),
    [api.collections.products.update.failure]: setIsFetching(false),
    [api.collections.sort.failure]: setIsFetching(false),
    [api.products.migrate.failure]: setIsFetching(false),
    [api.collections.retrieve.success]: setIsFetching(false),

    [api.collections.list.success]: setSuccessResult,
    [api.collections.sort.success]: setSuccessResult,
    [api.collections.update.success]: setSuccessResult,
    [api.collections.create.success]: setSuccessResult,
    [api.collections.delete.success]: setSuccessResult,
    [api.collections.products.update.success]: setSuccessResult,
    [api.products.migrate.success]: setSuccessResult,

    [api.products.sort.success]: setLastRequest,
});
